mutation revokeCompanyDeletionWithDelay($id: ID!) {
  revokeCompanyDeletionWithDelay(id: $id)
}
